export function guideTitle(pageTitle, stepTitle, duration) {
  const guideTitle = `
    <p class="text-blue text-subtitle md:text-headline2-lg font-black mb-4">${stepTitle}</p>
    <div class="flex align-middle justify-start items-center gap-2 mb-4"><svg class="w-4 h-4"><use xlink:href="/spritemap.svg#sprite-watch"></use></svg><span>${duration} min</span></div>

  `;
  return guideTitle;
}
